import { useLocalization } from '../../contexts/LocalizationContext';
import { getProductImageUrl } from '../../utils/formatters';
import Modal from '../../components/Common/Modal';
import Button from '../../components/Common/Button';

const ViewProductModal = ({ isOpen, onClose, product }) => {
  const { get, isRtl } = useLocalization();

  if (!product) return null;

  const imageUrl = getProductImageUrl(product.imageUrlFull || product.imageUrl);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isRtl ? product.nameAr : product.nameEn}
      footer={
        <Button variant="secondary" onClick={onClose}>
          {get('close')}
        </Button>
      }
    >
      <div style={{ display: 'grid', gap: 'var(--sp-4)' }}>
        <div className="view-product-image-wrap">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={isRtl ? product.nameAr : product.nameEn}
              style={{ width: '100%', borderRadius: 'var(--r-md)' }}
              onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling?.classList.add('visible'); }}
            />
          ) : null}
          <div className={`view-product-image-placeholder ${!imageUrl ? 'visible' : ''}`}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
            <span>{isRtl ? 'لا توجد صورة' : 'No image'}</span>
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">{isRtl ? 'الاسم (إنجليزي)' : 'Name (English)'}</label>
          <div>{product.nameEn}</div>
        </div>
        <div className="form-group">
          <label className="form-label">{isRtl ? 'الاسم (عربي)' : 'Name (Arabic)'}</label>
          <div>{product.nameAr}</div>
        </div>
        <div className="form-group">
          <label className="form-label">{isRtl ? 'العلامة التجارية' : 'Brand'}</label>
          <div>{isRtl ? product.brandAr : product.brandEn}</div>
        </div>
        <div className="form-group">
          <label className="form-label">{isRtl ? 'الفئة' : 'Category'}</label>
          <div>{isRtl ? product.categoryNameAr : product.categoryNameEn}</div>
        </div>
        {product.descriptionEn && (
          <div className="form-group">
            <label className="form-label">{isRtl ? 'الوصف (إنجليزي)' : 'Description (English)'}</label>
            <div>{product.descriptionEn}</div>
          </div>
        )}
        {product.descriptionAr && (
          <div className="form-group">
            <label className="form-label">{isRtl ? 'الوصف (عربي)' : 'Description (Arabic)'}</label>
            <div>{product.descriptionAr}</div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ViewProductModal;
